const onMenuOpenedAndClosed = (isOpenMenu?: boolean) => {
  // TODO: Search better solution: This fix solves the sticky bug visible when opening the mobile header
  const stickyOfferProduct = document?.getElementById('sticky-offer-product');
  if (!stickyOfferProduct) return;
  if (isOpenMenu) stickyOfferProduct.style.zIndex = '3';
  else stickyOfferProduct.style.zIndex = '4';
};

export { onMenuOpenedAndClosed };
